import React from "react";
import Page from "../templates/faq-page/main-banner";

import { Helmet } from "react-helmet";

const EventsPage = () => {
  return (
    <div style={{ overflow: "hidden" }}>
      <Helmet>
        <title>FAQ | Hirdaramani</title>
        <meta name="title" content="FAQ" />
        <meta name="description" content="FAQ" />
        <link
          rel="canonical"
          href="https://sustainability.hirdaramani.com/faq/"
        />
        <meta property="og:locale" content="en_US" />
        <meta name="keywords" content="FAQ" />
        <meta property="og:title" content="FAQ | Hirdaramani" />
        <meta property="og:description" content="FAQ" />
        <meta
          property="og:image"
          content="https://hirdaramani-microsite.sgp1.digitaloceanspaces.com/images/logo.png"
        />
        <meta
          property="og:url"
          content="https://sustainability.hirdaramani.com/faq/"
        />
      </Helmet>

      <Page />
    </div>
  );
};

export default EventsPage;
